// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');

// @actions
const raErrorHandlerActions = require('./RAErrorHandler');

const requestSimulationInProgressForObjective = () => {
    return {
        type: actionTypes.RA_SAVE_SIMULATION_REQUEST_FOR_OBJECTIVE,
    };
};

const requestSimulationInProgressForPortfolio = () => {
    return {
        type: actionTypes.RA_SAVE_SIMULATION_REQUEST_FOR_PORTFOLIO,
    };
};

const buildEmptySimulationForObjective = () => ({
    hasRecurringTransfer: false,
    endDate: '',
    name: '',
    type: 'ERROR',
    id: '001',
    error: true,
});

const buildEmptySimulationForPortfolio = () => ({
    amount: 0,
    initialContribution: 0,
    selectedPortfolio: '6',
    maxTypeOfProduct: 1,
    hasRecurringTransfer: false,
    endDate: '',
    name: '',
    type: '',
    id: '001',
    error: true,
});

const requestSimulationFailure = () => ({
    type: actionTypes.RA_SAVE_SIMULATION_REQUEST_FAILURE,
});

const requestSimulationSuccessForPortfolio = data => {
    const formattedData = !!data ? data : buildEmptySimulationForPortfolio();
    Object.keys(formattedData).filter(key => {
        const value = formattedData[key];
        if (value == null) {
            delete formattedData[key];
        }
    });
    return {
        type: actionTypes.RA_SAVE_SIMULATION_REQUEST_SUCCESS_FOR_PORTFOLIO,
        payload: formattedData,
    };
};

const requestSimulationSuccessForObjective = data => {
    const formattedData = !!data ? data : buildEmptySimulationForObjective();
    return {
        type: actionTypes.RA_SAVE_SIMULATION_REQUEST_SUCCESS_FOR_OBJECTIVE,
        payload: formattedData,
    };
};

const triggerPortfolioRequestSimulation = requestData => dispatch => {
    requestSimulationInProgressForPortfolio(); //This action is for requestSimulation Portfolio is in Progress
    return APIGet(dispatch, apiURLBuilder.getURL('raSimulation'), requestData)
        .then(response =>
            dispatch(requestSimulationSuccessForPortfolio(response)),
        )
        .catch(error => {
            if (error && error.code == '500') {
                dispatch(
                    requestSimulationSuccessForPortfolio(
                        buildEmptySimulationForPortfolio(),
                    ),
                );
            }
            dispatch(requestSimulationFailure());
        });
};

const triggerObjectiveRequestSimulation = requestData => dispatch => {
    requestSimulationInProgressForObjective(); //This action is for requestSimulation Objective is in Progres
    return APIGet(dispatch, apiURLBuilder.getURL('raSimulation'), requestData)
        .then(response =>
            dispatch(requestSimulationSuccessForObjective(response)),
        )
        .catch(error => {
            if (error && error.code == '500') {
                dispatch(
                    requestSimulationSuccessForObjective(
                        buildEmptySimulationForObjective(),
                    ),
                );
            }
        });
};

const requestSimulation = (pureRobo = false) => dispatch => {
    const requestData = {
        header: { version: 2 },
        query: {
            pureRobo: pureRobo,
        },
    };
    if (pureRobo) {
        dispatch(triggerPortfolioRequestSimulation(requestData)); //This action is for requestSimulation Portfolio is in Progress
    } else {
        dispatch(triggerObjectiveRequestSimulation(requestData)); //This action is for requestSimulation Objective is in Progress
    }
};

const saveSimulationInProgress = () => ({
    type: actionTypes.RA_SAVE_SIMULATION_REQUEST_TO_SAVE_DATA_FOR_PORTFOLIO,
});

const saveSimulationSuccessForPortfolio = data => {
    return {
        type: actionTypes.RA_SAVE_SIMULATION_SUCCESS_TO_SAVE_DATA_FOR_PORTFOLIO,
        payload: data,
    };
};

const saveSimulationSuccessForObjective = (gbi, data) => {
    return {
        type: actionTypes.RA_SAVE_SIMULATION_SUCCESS_TO_SAVE_DATA_FOR_OBJECTIVE,
        payload: data,
    };
};

const saveSimulationFailureForPortfolio = error => {
    return {
        type: actionTypes.RA_SAVE_SIMULATION_FAILURE_TO_SAVE_DATA_FOR_PORTFOLIO,
        payload: error,
    };
};

const saveSimulationFailureForObjective = error => {
    return {
        type: actionTypes.RA_SAVE_SIMULATION_FAILURE_TO_SAVE_DATA_FOR_OBECTIVE,
        payload: error,
    };
};

const triggerPortfolioSaveSimulation = (requestData, history) => dispatch => {
    dispatch(saveSimulationInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('raSimulation'), requestData)
        .then(response => dispatch(saveSimulationSuccessForPortfolio(response)))
        .catch(error => {
            if (error.error) {
                dispatch(
                    saveSimulationFailureForPortfolio(error.error.description),
                );
            } else {
                throw error;
            }
            raErrorHandlerActions.show(error, history);
        });
};

const triggerObjectiveSaveSimulation = (requestData, history) => dispatch => {
    return APIPost(dispatch, apiURLBuilder.getURL('raSimulation'), requestData)
        .then(response => dispatch(saveSimulationSuccessForObjective(response)))
        .catch(error => {
            if (error.error) {
                dispatch(
                    saveSimulationFailureForObjective(error.error.description),
                );
            } else {
                throw error;
            }
            raErrorHandlerActions.show(error, history);
        });
};

const saveSimulationRequest = (history, gbi = false) => (
    dispatch,
    getState,
) => {
    const immCustomPlanByObjective = getState().raCustomPlanByObjective;
    const immSimulation = gbi
        ? getState().raManagementPlan
        : immCustomPlanByObjective;
    const immTimeHorizonCheck = getState().raTimeHorizonCheck;
    const amount = immCustomPlanByObjective.get('objectiveAmount');
    const name = immCustomPlanByObjective.get('objective');
    const displayName = immSimulation.get('portfolioCustomName');
    const endDate = immCustomPlanByObjective.get('objectiveEndDate');
    const type =
        immCustomPlanByObjective.get('objectiveType') &&
        immCustomPlanByObjective.get('objectiveType').toUpperCase();
    const selectedPortfolio = gbi
        ? immSimulation.get('investProfileValue')
        : immSimulation.get('selectedStrategy');
    const initialContribution = immSimulation.get('initialContributionAmount');
    const maxTypeOfProduct = immTimeHorizonCheck.get('maxTypeOfProduct');
    const recurringContributionAmount = immSimulation.get(
        'recurringContributionAmount',
    );
    const pureRobo = gbi;
    let recurringTransfer;
    if (recurringContributionAmount) {
        recurringTransfer = {
            amount: immSimulation.get('recurringContributionAmount') || ' ',
            cutDay: gbi
                ? immSimulation.get('recurringContributionDay')
                : immSimulation.get('contributionDay'),
            frequencyCode: immSimulation.get('periodicity'),
        };
    }
    const request = {
        amount,
        currency: 'EUR',
        endDate,
        initialContribution,
        maxTypeOfProduct,
        name,
        displayName,
        recurringTransfer,
        selectedPortfolio,
        type,
        pureRobo,
    };
    let requestData = {
        header: {
            version: 2,
        },
        query: request,
    };

    if (pureRobo) {
        dispatch(triggerPortfolioSaveSimulation(requestData, history)); //This action is for requestSimulation Portfolio is in Progress
    } else {
        dispatch(triggerObjectiveSaveSimulation(requestData, history)); //This action is for requestSimulation Objective is in Progress
    }
};

module.exports = {
    requestSimulation,
    saveSimulationRequest,
};
